<template>
  <div v-if="!isLoading" class="mt-5">
    <div class="mt-3">
      <Label required>{{ $t("common.first_name") }}</Label>
      <InputField
        :disabled="true"
        v-model="state.form.firstName"
        class="d-block"
      ></InputField>
    </div>
    <div class="mt-3">
      <Label required>{{ $t("common.last_name") }}</Label>
      <InputField
        :disabled="true"
        v-model="state.form.lastName"
        class="d-block"
      ></InputField>
    </div>
    <div v-if="userRole === 'student'" class="mt-3">
      <Label required>{{ $t("common.email") }}</Label>
      <InputField
        :disabled="true"
        v-model="state.email"
        class="d-block"
      ></InputField>
    </div>
    <div v-if="isVisibleAllowAppRequest && userRole !== 'student'" class="mt-4">
      <div class="d-flex justify-content-between py-2">
        <Label>{{ $t("common.appointment_requests_to_you") }}</Label>
        <div class="pe-none">
          <CustomSwitch
            type="radio"
            v-model="state.form.allowAppRequest"
          ></CustomSwitch>
        </div>
      </div>
    </div>
    <div v-if="userRole !== 'student'" class="mt-4">
      <div class="d-flex justify-content-between py-2">
        <Label>{{ $t("common.passes_to_from_you") }}</Label>
        <div class="pe-none">
          <CustomSwitch
            type="radio"
            v-model="state.form.allowCreatePasses"
          ></CustomSwitch>
        </div>
      </div>
    </div>

    <div
      v-if="
        activeSchool.is_premium &&
        isActiveAppoinmentModule &&
        userRole !== 'student'
      "
      class="mt-4"
    >
      <div class="d-flex justify-content-between py-2">
        <div class="me-3 mt-4">
          <Label>{{ $t("common.appointment_pass_email_reminders") }}</Label>
        </div>
        <div>
          <div class="d-flex justify-content-between py-2">
            <Label>{{ $t("common.20_minute") }}</Label>
            <div class="pe-none">
              <CustomSwitch
                type="radio"
                class="ms-2"
                v-model="state.form.apt_reminder_emails['20min']"
              ></CustomSwitch>
            </div>
          </div>
          <div class="d-flex justify-content-between py-2">
            <Label>{{ $t("common.5_minute") }}</Label>
            <div class="pe-none">
              <CustomSwitch
                type="radio"
                class="ms-2"
                v-model="state.form.apt_reminder_emails['5min']"
              ></CustomSwitch>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="userRole !== 'student'" class="mt-4">
      <Label>{{ $t("common.pin") }}</Label>
      <InputField
        :placeholder="$t('common.pin_placeholder')"
        :disabled="true"
        v-model="state.form.pin"
        class="d-block"
      ></InputField>
    </div>
    <div
      v-if="
        userRole === 'student' &&
        isActiveKioskModule &&
        !activeSchool.hide_student_kiosk_passcode_field
      "
      class="mt-5"
    >
      <Label>Kiosk passcode</Label>
      <InputField
        placeholder="Enter Passcode"
        :disabled="true"
        class="d-block"
      ></InputField>
    </div>
  </div>
  <div v-else class="d-flex justify-content-center">
    <CSpinner color="primary" />
  </div>
</template>

<script>
import { reactive, computed, onMounted, ref } from "vue"
import { useStore } from "vuex"
import Label from "@/v3components/shared/Form/Label.vue"
import InputField from "@/v3components/shared/Form/InputField.vue"
import CustomSwitch from "@/v3components/shared/Form/CustomSwitch.vue"

export default {
  name: "UserProfileDetails",
  components: {
    Label,
    InputField,
    CustomSwitch
  },
  props: {
    user: {
      type: Object
    },
    avatar: {
      type: String,
      default: ""
    },
    userRole: {
      type: String,
      default: ""
    },
    activeAppoinmentModuleOptions: {
      type: Object
    },
    isActiveAppoinmentModule: {
      type: Boolean,
      default: false
    },
    isActiveKioskModule: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const store = useStore()
    const state = reactive({
      form: {
        firstName: "",
        lastName: "",
        newPass: "",
        allowAppRequest: true,
        allowCreatePasses: true,
        pin: "",
        apt_reminder_emails: {
          "20min": false,
          "5min": false
        }
      },
      email: props.user.email,
      isProcessing: false,
      serverErrors: {},
      serverRes: null
    })

    const isLoading = ref(true)

    onMounted(() => {
      isLoading.value = true
      store.dispatch("users/getSpecificUser", props.user).then((response) => {
        const profileData = {
          firstName: response.data.data.first_name,
          lastName: response.data.data.last_name,
          allowAppRequest: !!response.data.data.allow_appointment_requests,
          allowCreatePasses: !!response.data.data.allow_passes_to_me,
          pin: response.data.data.pin,
          apt_reminder_emails: {
            "20min": !!response.data.data.twenty_min_reminder,
            "5min": !!response.data.data.five_min_reminder
          }
        }
        isLoading.value = false
        state.form = Object.assign(state.form, profileData)
      })
    })

    const isVisibleAllowAppRequest = computed(() => {
      return (
        props.isActiveAppoinmentModule &&
        props.activeAppoinmentModuleOptions &&
        props.activeAppoinmentModuleOptions[props.userRole]
      )
    })

    const activeSchool = computed(() => store.getters["schools/activeSchool"])

    return {
      state,
      isVisibleAllowAppRequest,
      activeSchool,
      isLoading
    }
  }
}
</script>
